import React from 'react'
import styled from 'styled-components'
import { ReactComponent as SaleTagImg } from '../../../../assets/sale.svg'
import { useIsMobile } from '../../../../hooks/useIsMobile'

const Container = styled.div`
  border-bottom: 1px solid ${props => props.theme.tabs.line};
  user-select: none;
  display: flex;
  flex-wrap: nowrap;
  justify-content: stretch;
  align-items: stretch;
  align-self: stretch;
  margin-left: 16px;
  margin-right: 16px;
  overflow: hidden;
  flex: 0 0 40px;

  @media (max-width: 800px) {
    overflow: visible;
    border-bottom: none;
    margin-top: 10px;
  }
`

const Item = styled.div`
  flex: 1 1 0px;
`
/*
tabs: {
  active: '#000000',
  normal: '#777777',
  line: '#E5E5E5',
},
*/

const ListButton = styled.button`
  width: 100%;
  outline: none;
  border: 0;
  padding: 11px;
  margin: 0;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  background-color: transparent;
  font-size: 13px;
  font-weight: ${props => (props.active === false ? '500' : '700')};
  color: ${props =>
    props.active === false ? '#777777' : props.theme.tabs.active};
  border-bottom: ${props =>
    props.active === false ? 'none' : '4px solid' + props.theme.tabs.active};
  white-space: nowrap;
  position: relative;
`

const Tab = ({ data, onClick, active }) => {
  const isMobile = useIsMobile()

  return (
    <Item>
      <ListButton
        active={data.value === active.value ? true : false}
        onClick={e => onClick(data)}
      >
        {data.label}
        {data.value === 'purchased' && (
          <SaleTagImg
            style={{
              position: 'absolute',
              right: isMobile ? -5 : 5,
              top: isMobile ? -4 : 3
            }}
          />
        )}
      </ListButton>
    </Item>
  )
}

const ListTabs = ({ options, onClick, selected }) => {
  return (
    <Container>
      {options.map(item => (
        <Tab key={item.value} data={item} onClick={onClick} active={selected} />
      ))}
    </Container>
  )
}

export default ListTabs
